export default {
	updatePassword: {
        error: '',
        success: false,
        loading: false
    },
}